import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { AdminAreaView } from "@/lib/api/types";
import { endpoints } from "@/lib/api/endpoints";
import { apiJsonClient } from "@/lib/query/core/api-json-client";
import { invalidateAdminAreas } from "@/lib/query/core/invalidation";

type UpdateAreaInput = {
  id: string;
  nameAr?: string;
  nameEn?: string;
  isActive?: boolean;
};

export function useUpdateAreaMutation() {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: ({ id, ...body }: UpdateAreaInput) =>
      apiJsonClient<AdminAreaView>(endpoints.admin.areaById(id), {
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      }),
    onSuccess: async () => {
      await invalidateAdminAreas(queryClient);
    },
  });

  return {
    mutateAsync: mutation.mutateAsync,
    isPending: mutation.isPending,
    error: mutation.error,
    reset: mutation.reset,
  };
}
